export default {
  'profileaccounts.accountsmanagement': 'Управление банковскими счетами',
  'profileaccounts.bankname': 'Название банка',
  'profileaccounts.branchname': 'Название филиала',
  'profileaccounts.accountno': 'Номер счета',
  'profileaccounts.cardno': 'Номер карты',
  'profileaccounts.shebano': 'Номер ШЕБА',
  'profileaccounts.ismain': 'Ваш счет',
  'profileaccounts.register': 'регистр',
  'profileaccounts.delete': 'удалять',
  'profileaccounts.deleteaccount': 'Удалить банковский счет',
  'proprofileaccountsfile.cancel': 'Отмена',
  'profileaccounts.deleteconfirmation':
    'Вы уверены, что хотите удалить банковский счет ?',
  'profileaccounts.accountadd': 'Банковский счет успешно добавлен!',
  'profileaccounts.tryagain': 'Пожалуйста, попробуйте снова',
  'profileaccounts.enterinfo': 'введите информацию об учетной записи',
  'profileaccounts.addaccount': 'Bankkonto hinzufügen',
  'profileaccounts.cardno-account': 'Номер карты/счета',
  'profileaccounts.Textaccountsmanage':
    'Вы можете зарегистрировать желаемую учетную запись через следующую форму.',
};
